import { FaWhatsapp } from "react-icons/fa";
import React, { useContext, useState } from "react";
import logo from "../photos/logo.png";
import "./header.css";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../settings/LanguageContext";

const Header = () => {
  const { lang, toggleLanguage } = useContext(LanguageContext);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <header className="header">
      <div className="maincontainer">
        
        {/* LEFT — Logo */}
        <NavLink to="/">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
        </NavLink>

        {/* CENTER — Navigation */}
        <nav className="menu">
          <ul className={`menuul ${menuOpen ? "active" : ""}`}>
            <li>
              <NavLink to="/tours">
                {lang === "EN" ? "Tours" : "Туры"}
              </NavLink>
            </li>

            <li>
              <NavLink to="/gallery">
                {lang === "EN" ? "Gallery" : "Галерея"}
              </NavLink>
            </li>

            <li>
              <NavLink to="/about">
                {lang === "EN" ? "About Us" : "О нас"}
              </NavLink>
            </li>

            <li>
              <NavLink to="/contactus">
                {lang === "EN" ? "Contact Us" : "Контакты"}
              </NavLink>
            </li>
          </ul>
        </nav>

        {/* RIGHT — Buttons (ALWAYS VISIBLE) */}
        <div className="header-buttons">
          <NavLink to="/inquery">
            <button className="btninqloc">
              {lang === "EN" ? "Tour Inquiry" : "Запрос тура"}
            </button>
          </NavLink>

          <a
            href="https://wa.me/37493106810"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn" id="wpbtonlybl">
              <FaWhatsapp style={{ marginRight: "5px" }} />
              WhatsApp
            </button>
          </a>

          <div
            className={`lang-switch ${lang === "RU" ? "ru" : ""}`}
            onClick={toggleLanguage}
          >
            <div className="lang-knob">{lang}</div>
          </div>

          {/* Hamburger */}
          <div className="hamburger" onClick={toggleMenu}>
            <div
              style={{
                transform: menuOpen
                  ? "rotate(45deg) translate(5px,5px)"
                  : "none",
              }}
            />
            <div style={{ opacity: menuOpen ? 0 : 1 }} />
            <div
              style={{
                transform: menuOpen
                  ? "rotate(-45deg) translate(6px,-6px)"
                  : "none",
              }}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
